import { DataGridRef } from 'devextreme-react/data-grid'
import React from 'react'

export const useHandleKbEventsCallback = (currentGrid: DataGridRef | null, currentDropdownBox: any, opts: any[]) => {
    const handleDblClick = (row: any) => {
        row?.click()
        row?.click()
    }

    const handleKbEvents = async (e: any) => {
        const selectedRows = currentGrid?.instance().getSelectedRowKeys() || []
        const visibleRowKeys = currentGrid?.instance().getVisibleRows().map((row: any) => row.key) || []

        if ((e.which === 40 || e.which === 38) && (!selectedRows || selectedRows?.length === 0)) {
            currentGrid?.instance().selectRowsByIndexes([0])
            return
        }

        const currentIndex = currentGrid?.instance().getRowIndexByKey(selectedRows[0]) || 0
        if (e.which === 40) {
            // arrowDown
            const nextIndex = currentIndex === opts.length - 1 ? currentIndex : currentIndex + 1
            const nextKey = currentGrid?.instance().getKeyByRowIndex(nextIndex)
            await currentGrid?.instance().selectRows([nextKey], false)
            currentGrid?.instance().navigateToRow(nextKey)
        } else if (e.which === 38) {
            // arrowUp
            const prevIndex = currentIndex === 0 ? currentIndex : currentIndex - 1
            const prevKey = currentGrid?.instance().getKeyByRowIndex(prevIndex)
            await currentGrid?.instance().selectRows([prevKey], false)
            currentGrid?.instance().navigateToRow(prevKey)
        } else if (e.which === 13) {
            // enter
            // if no row is selected and only one row is showing, select it before closing
            if ((!selectedRows || selectedRows.length === 0) && visibleRowKeys.length === 1) {
                currentGrid?.instance().selectRows([visibleRowKeys[0]], false)
            }
            handleDblClick(currentGrid?.instance().element().querySelector('tr.dx-row-lines.dx-selection'))

            // and close popup
            currentDropdownBox?.instance().close()
        }
    }

    return handleKbEvents
}